<template>
 <v-layout id="login" :class="{ 'justify-center': $root.isTouch,  'justify-space-between': !$root.isTouch}" class="padding" row fill-height align-center >
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  <v-flex xs12 sm6 md6 lg3 class="text-xs-center">
    <img class="responsive-img" src="./../assets/img/logo.png" style="height: 200px; width: auto" alt="fresh start logo">
    <v-form class="text-xs-center hidden-lg-and-up" @submit.prevent="signInWithEmailAndPass()" >
      <v-text-field
        box
        dark
        :rules="[rules.required]"
        label="Full Name"
        name="name"
        type="name"
        v-model="name"
        prepend-icon="account_circle"
      ></v-text-field>
      <v-text-field
        box
        dark
        :rules="[rules.required]"
        label="Email"
        name="email"
        type="email"
        v-model="email"
        prepend-icon="account_circle"
      ></v-text-field>
      <v-text-field
          box
          dark
          :append-icon="show1 ? 'visibility_off' : 'visibility'"
          :rules="[rules.required]"
          :type="show1 ? 'text' : 'password'"
          name="input-10-2"
          label="Password"
          v-model="password"
          prepend-icon="lock"
          @click:append="show1 = !show1"
        ></v-text-field>
      <v-btn type="submit" block color="primary" :loading="loading" :disabled="isDisabled">Sign up</v-btn>
    </v-form>
  </v-flex>
  <v-flex id="welcome" class="hidden-md-and-down text-lg-center" fill-height align-content-center lg6>
    <v-layout row align-center justify-center fill-height wrap>
      <v-flex xs8>
        <h1>Welcome to</h1>
        <a href="https://leaner-living.com/">
          <img src="https://leaner-living.com/images/LEANER-LIVING-LOGO.png" alt="LEANER-LIVING-LOGO" class="responsive-img" style="width: 40%;">
        </a>
        <v-form class="text-xs-center"  @submit.prevent="signInWithEmailAndPass()" >
          <v-text-field
            box
            dark
            :rules="[rules.required]"
            label="Full Name"
            name="name"
            type="name"
            v-model="name"
            prepend-icon="account_circle"
          ></v-text-field>
          <v-text-field
            box
            dark
            :rules="[rules.required]"
            label="Email"
            name="email"
            type="email"
            v-model="email"
            prepend-icon="account_circle"
          ></v-text-field>
          <v-text-field
            box
            dark
            :append-icon="show1 ? 'visibility_off' : 'visibility'"
            :rules="[rules.required]"
            :type="show1 ? 'text' : 'password'"
            name="input-10-2"
            label="Password"
            v-model="password"
            prepend-icon="lock"
            @click:append="show1 = !show1"
          ></v-text-field>
          <v-btn type="submit" block color="primary" :loading="loading" :disabled="isDisabled">Sign up</v-btn>
        </v-form>
      </v-flex>
    </v-layout>
  </v-flex>
  </v-layout>
</template>
<script>
import { db, auth } from '@/services/firebase'
export default {
  data () {
    return {
      loading: false,
      name: '',
      email: '',
      dialog: false,
      password: '',
      rules: {
        required: value => !!value || 'Required.'
      },
      show1: false
    }
  },
  props: ['isTouch'],
  beforeRouteEnter (to, from, next) {
    const token = decodeURIComponent(to.query.token)
    const queryParams = token.split('&')
    if (queryParams[1] === 'c9739d6d774a4da1ae31ed90424bf13d') {
      next()
    } else {
      next({ path: '/login' })
    }
  },
  mounted () {
    this.email = this.$route.query.email
  },
  methods: {
    signInWithEmailAndPass: function () {
      this.loading = true
      var self = this
      const token = decodeURIComponent(this.$route.query.token)
      const queryParams = token.split('&')
      var fresh = false
      var one2one = false
      var trial = false
      var phase = null
      if (queryParams[0] === 'fresh') {
        fresh = true
        phase = 1
      } else if (queryParams[0] === 'one2one') {
        one2one = true
      } else if (queryParams[0] === 'trial') {
        trial = true
      }
      auth.createUserWithEmailAndPassword(self.email, self.password)
        .then(function (result) {
          db.collection('users').doc(result.user.uid).set({
            name: self.name,
            email: result.user.email,
            admin: false,
            active: true,
            graduate: false,
            fresh: fresh,
            one2one: one2one,
            trial: trial,
            commenced_at: null,
            phase: phase
          })
            .then(function (docRef) {
              self.$store.dispatch('setCurrentUser', result.user.uid).then(() => {
                self.$store.dispatch('fetchUserProfile')
              })
            })
            .catch(function (error) {
              self.loading = false
              alert('Error: Error adding user information')
              console.error('Error adding user: ', error)
            })
        })
        .catch(function (error) {
          // Handle Errors here.
          self.loading = false
          var errorCode = error.code
          var errorMessage = error.message
          alert(errorCode + errorMessage)
        })
    }
  },
  computed: {
    isDisabled () {
      if (this.email && this.name && this.password) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>
<style scoped>
  #login {
    background-image: url('./../assets/img/yoga.jpg');
    background-size: cover;
    background-position: center;
  }
  #login::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: -webkit-gradient(linear, left top, right bottom, from(#64d9c4), color-stop(#58c49f), color-stop(#53af7a), color-stop(#539955), to(#538330));
    background: linear-gradient(to right bottom, #64d9c4, #58c49f, #53af7a, #539955, #538330);
    opacity: .6;
    z-index: 1;
  }
  #login .flex {
    z-index: 2;
  }
  #login form {
    margin-top: 24px;
  }
  #welcome {
    background-color: #fff;
  }
  /* @media screen and (min-width: 1264px) {
    #login {
      background-size: 50% 100%;
      background-position: left;
    }
    #login::before {
    width: 50%;
    }
  }  */
</style>



// WEBPACK FOOTER //
// src/components/signUpPass.vue